import "./history-section.scss";

const HistorySection = () => {
  return (
    <section id="history-section" className="history-section py-[96px]">
      <div className="px-[30px] md:px-[46px] flex flex-col gap-12 max-w-[540px] mx-auto md:max-w-none lg:max-w-[1140px]">
        <h2>Historie</h2>
      </div>
    </section>
  );
};

export default HistorySection;
